import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Text } from 'foundations-components/components/Text';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ContentPopoverEmptyState = ({
  image,
  title,
  description,
  buttonLabel,
  buttonLink
}) => /*#__PURE__*/_jsxs(TFlex, {
  direction: "column",
  align: "center",
  padding: "200",
  children: [image && /*#__PURE__*/_jsx(Illustration, {
    name: image,
    height: 150,
    width: 150,
    marginBlockEnd: "300"
  }), /*#__PURE__*/_jsx(Text, {
    as: "h5",
    marginBlockEnd: "500",
    textAlign: "center",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: title
    })
  }), /*#__PURE__*/_jsx(Text, {
    as: "span",
    marginBlockEnd: "500",
    textAlign: "center",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: description
    })
  }), /*#__PURE__*/_jsx(Button, {
    use: "tertiary",
    external: true,
    href: buttonLink,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: buttonLabel
    })
  })]
});
export default ContentPopoverEmptyState;